export const buttonVariants = {
  primary: 'odin-btn-primary',
  secondary: 'odin-btn-secondary', 
  outline: 'odin-btn-outline',
  ghost: 'odin-btn-ghost',
  destructive: 'odin-btn-destructive',
  'table-action': 'odin-btn-table-action'
}

export const buttonSizes = {
  mini: 'odin-btn-mini',
  small: 'odin-btn-small',
  regular: 'odin-btn-regular',
  large: 'odin-btn-large'
}